import React, { useCallback } from 'react'
import Text from '../../atoms/text/Text'
import VerticalGroup from '../../atoms/verticalgroup/VerticalGroup'
import InlineGroup from '../../atoms/inlinegroup/InlineGroup'
import Card from '../../atoms/card/Card'

import './RoundResultsTablePage.scss'
import { useResultsContext } from './context/context'
import EditableText from '../../atoms/text/EditableText'

interface Props {
  data: API.ReportingLayoutCustomTextConfig
}

const RoundResultsCustomText: React.FC<Props> = ({ data }) => {
  const context = useResultsContext()
  const onChange = useCallback((val: API.ReportingLayoutCustomTextConfig) => {
    if (context.onCustomTemplateEdit) {
      context.onCustomTemplateEdit({
        config: val
      })
    }
  }, [context])

  return (
    <VerticalGroup full center wide>
      {context.allowCustomTemplateEdits ?
        <EditableText
          type='text'
          value={data.heading}
          size='6xl'
          bold
          colour='primaryDark'
          className='mb-2'
          alignment='horizontal'
          onChange={(val: string) => {
            onChange({
              ...data,
              heading: val
            })
          }}
        /> :
        <Text size='6xl' bold colour='primaryDark' className='mb-2'>{data.heading}</Text>}
      <InlineGroup fullHeight block >
        <Card wide sharp padding={4}>
          <InlineGroup fullHeight block>
            {context.allowCustomTemplateEdits ?
              <EditableText
                value={data.body}
                size='lg'
                clickableStyle={{ width: '100%', display: 'flex', alignItems: 'flex-start' }}
                onChange={(val: string) => {
                  onChange({
                    ...data,
                    body: val
                  })
                }}
              /> :
              <Text size='lg' dangerouslySetInnerHTML={{ __html: data.body}} />}
          </InlineGroup>
        </Card>
      </InlineGroup>
    </VerticalGroup>
  )
}

export default RoundResultsCustomText

